// What the first tab is called, which depends on what the phone has.
//
// THE TRAINS TAB IS ALSO EVERY OTHER MODE'S TAB (trams, and whatever a city
// declares in src/modes.js), and "TRAINS" over a board of
// trams says the wrong thing at the one place the whole app is navigated from.
// With trams on it reads BOARD.
//
// WHY BOARD. It has to cover both modes, so it cannot name either; it has to
// fit the bar, which is Martian Mono at 10px and truncates ten letters at
// 375px (see the note on GAME in router.js), so DEPARTURES is out; and it
// should be a word this app already says. The app calls the thing "the
// board" in every sentence that is about it — "the board opens on it", "the
// board is a station's" — and a departures board is what a tram stop has too.
// Five letters, one word, in the register of LINES, GAME and ALERTS.
//
// A TRAIN-ONLY PHONE KEEPS TRAINS, UNCHANGED. TRAINS is plain to somebody
// who has just installed a train app and has never heard what a "board" is,
// and it is true for them. BOARD earns its place only once there is something
// for TRAINS to be wrong about, so the label follows the switch the same way
// every other tram-shaped thing does.

/**
 * The departures tab's label. `modes` is how many modes with a board of their
 * own the phone has on (a count, or a plain boolean): none keeps TRAINS, one or
 * more makes the tab hold more than one kind of board, which is BOARD.
 */
export function departuresLabel(modes) {
  return Number(modes) > 0 || modes === true ? 'Board' : 'Trains';
}

/** The label for a tab, whatever tab it is. */
export function tabLabel(tab, modes) {
  return tab?.name === 'departures' ? departuresLabel(modes) : tab?.label;
}
